
<template>
<Loader v-if="loader" />

  <div class="card p-3">
    <div class="grid">
        <div class="col-12 lg:col-5">
          <label>Tipo Fornitura</label>
          <Dropdown v-model="selectedTypeFornitura" :options="typesFornitura" optionLabel="name" optionValue="name"  class="inputfield w-full" />
        </div>
        <div class="col-12 lg:col-5">
          <label>Periodo Competenza</label>
           <Calendar v-model="selectedDate" :showIcon="true" selectionMode="range" view="month" dateFormat="mm-yy" class="inputfield w-full" />
           <div v-show="validationErrors.date && submitted" class="p-error">Periodo non valido.</div>
        </div>
        <div class="col-12 lg:col-2 flex align-items-end">
          <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" class="w-full" />
        </div>
    </div>
  </div>


  <Accordion v-if="Object.keys(items).length > 0" :multiple="true" v-model:activeIndex="activeTabIndex" lazy>
    <AccordionTab  v-for="(objs, type) in items" :key="type" :header="type.toUpperCase()">
      <Accordion :multiple="true" lazy>
        <AccordionTab v-for="(obj, fornitore) in objs" :key="fornitore" :header="fornitore">
            <DataTable :value="Object.values(obj)" rowGroupMode="rowspan" groupRowsBy="date">
              <Column field="date" header="Data" style="min-width: 120px" />
              <Column field="qta" header="Qta" style="min-width: 120px"></Column>
              <Column field="imponibile" header="Imponibile" style="min-width: 120px">
                <template #body="{data}">
                  {{formatCurrency(data.imponibile)}}     
                </template>
              </Column>
              <Column field="cmor" header="Cmor" style="min-width: 120px">
                <template #body="{data}">
                  {{formatCurrency(data.cmor)}}     
                </template>
              </Column>
               <ColumnGroup type="footer">
                  <Row>
                    <Column :colspan="1" class="td-footer" footer="Totali"/>
                    <Column :colspan="1" class="td-footer" :footer="totale_qta(type, fornitore)" />
                    <Column :colspan="1" class="td-footer" :footer="totale_imponibile(type, fornitore)" />
                    <Column :colspan="1" class="td-footer" :footer="totale_cmor(type, fornitore)" />
                  </Row>
                </ColumnGroup>
            </DataTable>
        </AccordionTab>
      </Accordion> 
    </AccordionTab>
  </Accordion>

</template>

<script>

import { ref, getCurrentInstance } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import Loader from '@/components/Loader.vue'
import moment from 'moment';

export default {
    components: {
      Loader
    },
     setup() {
                
      const loader = ref(false);
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)
      const activeTabIndex = ref(0);
      const items= ref([]);
      const selectedDate = ref([
        moment().startOf('year').toDate(),
        moment().endOf('year').toDate(),
      ]);
      const typesFornitura = ref([
        // {name: 'TUTTI'},
        {name: 'Energia'},
        {name: 'Gas'},
      ])
      const selectedTypeFornitura = ref(typesFornitura.value[0].name)
      const expandedRows = ref([]);
      const validationErrors = ref({})
      const submitted = ref(false)


      const searchData = () => {
        submitted.value = true
        if (validateForm()) {
          activeTabIndex.value = null
          loader.value = true;
          let d1 = moment(selectedDate.value[0]).startOf('month').format('YYYY-MM-DD')
          let d2 = moment(selectedDate.value[1]).endOf('month').format('YYYY-MM-DD')
          service.getAnalisiFornitori(selectedTypeFornitura.value, d1, d2)
          .then((res) => {
            items.value = res.items;
            console.log(items.value);
          }).finally(() => {
            loader.value = false;
          })
        }
      }


      const totale_qta = (type, fornitore) => {
        let total = 0;
        Object.values(items.value[type][fornitore]).forEach(el => {
          total += el.qta;
        });
        return total;
      };


      const totale_imponibile = (type, fornitore) => {
        let total = 0;
        Object.values(items.value[type][fornitore]).forEach(el => {
          total += el.imponibile;
        });
        return formatCurrency(total);
      };

      const totale_cmor = (type, fornitore) => {
        let total = 0;
        Object.values(items.value[type][fornitore]).forEach(el => {
          total += el.cmor;
        });
        return formatCurrency(total);
      };


      const validateForm = () => {
        if (selectedDate.value != null && selectedDate.value.length == 2 && selectedDate.value.every((el) => el != null)) {
          delete validationErrors.value['date'];
        } else {
          validationErrors.value['date'] = true;
        }

        return !Object.keys(validationErrors.value).length;
      }



      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };



        
      return { 
        loader,
        formatDate, 
        filters,
        searchData,
        selectedDate,
        activeTabIndex,
        items,
        selectedTypeFornitura,
        typesFornitura,
        expandedRows,
        moment,
        totale_qta,
        totale_imponibile,
        totale_cmor,
        formatCurrency,
        submitted,
        validationErrors,
        }
    }
}
</script>
